import { render, staticRenderFns } from "./PostStyleMobile.vue?vue&type=template&id=16c6a3d8"
import script from "./PostStyleMobile.vue?vue&type=script&lang=js"
export * from "./PostStyleMobile.vue?vue&type=script&lang=js"
import style0 from "./PostStyleMobile.vue?vue&type=style&index=0&id=16c6a3d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports